import bookingRewards from 'assets/core/js/page/red-booking/customer-zone/booking-rewards'
import dataLayer from 'assets/core/js/page/red-booking/customer-zone/data-layer'
import plainPassword from 'assets/themes/campings/js/module/plain-password'
import cancellationPages from 'assets/themes/campings/js/page/red-booking/customer-zone/cancellation-pages'
import paymentScheduleToggle from 'assets/themes/campings/js/page/red-booking/customer-zone/payment-schedule-toggle'

const currentPageType = document.body.getAttribute('data-pagetype') as string

document.addEventListener('DOMContentLoaded', function () {
  if (/(customer-zone-subscribe|customer-zone-login|customer-zone-new-password)/.test(currentPageType)) {
    plainPassword.init()
  }

  dataLayer()
  paymentScheduleToggle()
  cancellationPages()
  bookingRewards()
})
